<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6" lg="4">
                <v-card class="elevation-1">
                    <v-toolbar color="primary">
                        <!-- <v-toolbar-icon>
                        <v-img
                            :src="require('../assets/logo-48x48.png')"
                            class="mr-3"
                            height="30"
                        ></v-img></v-toolbar-icon>-->
                        <v-toolbar-title class="white--text"
                            >Greenie</v-toolbar-title
                        >
                        <v-spacer />
                    </v-toolbar>
                    <v-card-text class="mt-10 pb-0">
                        <v-form ref="loginForm">
                            <v-text-field
                                placeholder="Email"
                                name="login"
                                prepend-icon="person"
                                type="email"
                                :rules="[rules.required]"
                                :error-messages="error"
                                outlined
                                v-model="email"
                            />

                            <v-text-field
                                id="password"
                                placeholder="Password"
                                prepend-icon="lock"
                                name="password"
                                type="password"
                                :rules="[rules.required]"
                                :error-messages="error"
                                outlined
                                v-model="password"
                                @keydown.enter="login()"
                            />
                        </v-form>
                    </v-card-text>
                    <p class="text-center mx-0 px-10 pb-10">
                        <v-btn
                            color="primary"
                            outlined
                            rounded
                            width="280"
                            :loading="isSaving"
                            @click="login"
                            >Login</v-btn
                        >
                    </p>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import helper from "@/utils/helper.js";
export default {
    data: function() {
        return {
            isSaving: false,
            email: "",
            password: "",
            error: "",
            mess: "",
            rules: {
                required: v => !helper.isEmpty(v) || "This field is required",
                listRequired: v =>
                    (v || "").length >= 1 || `This field is required`,
                minLength: len => v =>
                    (v || "").length >= len || `Require at least ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long"
                // nameRules: [
                //     v => !!v || "Name is required",
                //     v =>
                //         v.length <= 50 || "Name must be less than 50 characters"
                // ]
            }
        };
    },
    methods: {
        login() {
            this.error = null;

            // check if form valid
            if (!this.$refs.loginForm.validate()) {
                return;
            }

            this.isSaving = true;

            var payload = { email: this.email, password: this.password };

            this.$store
                .dispatch("user/login", payload)
                .then(() => {
                    this.fetchMe();
                    this.$router.push(this.$route.query.redirect || "/");
                })
                .catch(error => {
                    /*handle errors*/
                    this.error = error.graphQLErrors[0].message;
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },

        fetchMe() {
            this.$store
                .dispatch("user/fetchMe")
                .then(() => {})
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
</script>